import { Room, RoomEvent, setLogLevel, VideoPresets } from "livekit-client";
import { DisplayContext, DisplayOptions, LiveKitRoom } from "@livekit/react-components";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import logo from "./icons/logo.webp";

import { ReactComponent as Microphone } from "./icons/microphone.svg";
import { ReactComponent as FilterAlt } from "./icons/Filter_alt.svg";
import { ReactComponent as PhoneLight } from "./icons/Phone_light.svg";
import { ReactComponent as StarLight } from "./icons/Star_light.svg";

export const RoomPage = () => {
  // const [, setNumParticipants] = useState(0);

  const [startConversation, setStartConversation] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isBotSpeaking, setIsBotSpeaking] = useState(false);
  const [connected, setConnected] = useState(false);

  const [displayOptions] = useState<DisplayOptions>({
    stageLayout: "grid",
    showStats: false
  });
  const roomRef = useRef<Room | null>(null);


  // const [egressId, setEgressId] = useState<string | null>(null);
  // const egressStartingRef = useRef(false);

  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const url = query.get("url");
  const token = query.get("token");
  // const recorder = query.get("recorder");
  // const roomName = query.get("room_name");
  // const project = query.get("project");
  // const roomName = query.get("room_name");

  // console.log("Room Name:", roomName);

  

  const startConversationApi = async () => {
    try {
      const roomName = sessionStorage.getItem("room_name");

      const res = await fetch(
        "http://your-backend-url/start-conversation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            room_name: roomName,
          }),
        }
      );

      const data = await res.json();

      console.log("API Response:", data);
    } catch (err) {
      console.error(err);
    }
  };


  const [activeModal, setActiveModal] = useState<
    "rating" | "support" | "settings" | null
  >(null);


  // const updateParticipantSize = (room: Room) => {
  //   setNumParticipants(room.participants.size + 1);
  // };

  useEffect(() => {
    if (!connected) return;

    let audioCtx: AudioContext;
    let analyser: AnalyserNode;
    let dataArray: Uint8Array;
    let raf: number;

    const start = async () => {
      audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();

      if (audioCtx.state === "suspended") {
        await audioCtx.resume();
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const source = audioCtx.createMediaStreamSource(stream);

      analyser = audioCtx.createAnalyser();
      analyser.fftSize = 1024;
      analyser.smoothingTimeConstant = 0.85;

      dataArray = new Uint8Array(analyser.fftSize);

      source.connect(analyser);

      const tick = () => {
        analyser.getByteTimeDomainData(dataArray);

        let sum = 0;
        for (let i = 0; i < dataArray.length; i++) {
          const v = (dataArray[i] - 128) / 128;
          sum += v * v;
        }
        const rms = Math.sqrt(sum / dataArray.length);
        const level = Math.min(rms * 3, 1);

        document.documentElement.style.setProperty("--voice-level", level.toString());
        setIsSpeaking(level > 0.03);

        raf = requestAnimationFrame(tick);
      };

      tick();
    };

    start();

    return () => {
      cancelAnimationFrame(raf);
      audioCtx?.close();
    };
  }, [connected]);

  // const onParticipantDisconnected = (room: Room) => {
  //   updateParticipantSize(room);
  //
  //   if (recorder && parseInt(recorder, 10) === 1 && room.participants.size === 0) {
  //     console.log("END_RECORDING");
  //   }
  // };

  // const startEgress = useCallback(async () => {
  //   if (egressId) return;
  //   if (!roomName || !project) return;
  //
  //   if (egressStartingRef.current) return;
  //   egressSta
  //   rtingRef.current = true;
  //
  //   try {
  //     const res = await fetch("http://localhost:9999/start_egress", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         project_name: project,
  //         room_name: roomName
  //       })
  //     });
  //
  //     const data = await res.json();
  //     if (data?.egress_id) {
  //       setEgressId(String(data.egress_id));
  //     } else {
  //       console.warn("شروع ضبط ناموفق بود", data);
  //     }
  //   } catch (err) {
  //     console.error("خطا در شروع ضبط:", err);
  //   } finally {
  //     egressStartingRef.current = false;
  //   }
  // }, [egressId, project, roomName]);

  // const stopEgress = useCallback(async () => {
  //   if (!egressId) return;
  //   if (!project) return;
  //
  //   try {
  //     await fetch("http://localhost:9999/stop_egress", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         project_name: project,
  //         egress_id: egressId
  //       })
  //     });
  //
  //     setEgressId(null);
  //   } catch (err) {
  //     console.error("خطا در توقف ضبط:", err);
  //   }
  // }, [egressId, project]);

  const onLeave = useCallback(async () => {
    // if (egressId) await stopEgress();
    navigate("/");
  }, [navigate]);

  // useEffect(() => {
  //   if (!connected) return;
  //   void startEgress();
  // }, [connected, startEgress]);

  if (!url || !token) {
    return <div className="errorBox">URL and token are required</div>;
  }

  return (
    <DisplayContext.Provider value={displayOptions}>
      <div className="page-shell">
        <div className="room-wrapper voice-ui">
          {/* TOP BAR */}
          <header className="room-topbar">
            <div className="header-right">
              <img
                src={logo}
                alt="logo"
                className="brand-logo"
                draggable={false}
              />
              <span className="brand-text">ویس‌بات</span>
            </div>

            <div className="left-icons">
              <button
                className="header-btn"
                onClick={() => setActiveModal("rating")}
              >
                <StarLight className="header-icons" />
              </button>

              <button
                className="header-btn"
                onClick={() => setActiveModal("support")}
              >
                <PhoneLight className="header-icons" />
              </button>

              <button
                className="header-btn"
                onClick={() => setActiveModal("settings")}
              >
                <FilterAlt className="header-icons" />
              </button>

            </div>
          </header>

          {/* STAGE */
          }
          <main className="room-stage">
            <div
              className={`orb-wrapper ${
                isBotSpeaking ? "orb-bot-speaking" : isSpeaking ? "orb-speaking" : "orb-idle"
              }`}
            >
              <div className="voice-ring"></div>
              <div className="voice-ring delay-1"></div>
              <div className="voice-ring delay-2"></div>

              <div
                className={`voice-orb ${
                  isBotSpeaking ? "voice-orb-bot-speaking" : isSpeaking ? "voice-orb-speaking" : "voice-orb-idle"
                }`}
              >

                {isBotSpeaking ?
                  <p className={"dots"}>...</p>
                  :
                  <Microphone className="stage-icons" />
                }
              </div>
            </div>

            {startConversation && (
              <div className="voice-hint">
                {connected ? "" : "در حال اتصال..."}
              </div>
            )}

            {/* ================= MODAL ================= */}

            {activeModal && (
              <div
                className="modal-overlay"
                onClick={() => setActiveModal(null)}
              >
                <div
                  className="custom-modal"
                  onClick={(e) => e.stopPropagation()}
                >

                  <button
                    className="modal-close"
                    onClick={() => setActiveModal(null)}
                  >
                    ✕
                  </button>

                  {activeModal === "rating" && (
                    <>
                      <h2>ارزیابی کیفیت مکالمه</h2>

                      <p>
                        از کیفیت پاسخ‌های ویس‌بات چقدر رضایت داشتید؟
                      </p>

                      <div className="rating-row">
                        <button>😍 عالی</button>
                        <button>🙂 خوب</button>
                        <button>😐 متوسط</button>
                        <button>😕 ضعیف</button>
                      </div>
                    </>
                  )}

                  {activeModal === "support" && (
                    <>
                      <h2>پشتیبانی</h2>

                      <p>
                        برای ارتباط با پشتیبانی شاتل با شماره زیر تماس بگیرید.
                      </p>

                      <div className="support-box">
                        021-91000000
                      </div>
                    </>
                  )}

                  {activeModal === "settings" && (
                    <>
                      <h2>تنظیمات صدا</h2>

                      <p>
                        به‌زودی تنظیمات پیشرفته میکروفون و کیفیت صدا
                        در این بخش اضافه خواهد شد.
                      </p>
                    </>
                  )}

                </div>
              </div>
            )}

            {!startConversation && (
              <div className={"welcomeOverlay"}>
                <div className={"welcomeContent"}>
                  <p className={"welcomeText"}>
                    سلام من ویس‌بات هستم.
                    <br />
                    برای شروع روی دکمه کلیک کنید.
                  </p>

                  <button
                    className={"welcomeButton"}
                    onClick={async () => {
                      await startConversationApi();
                      setStartConversation(true);
                    }}
                  >
                    شروع مکالمه
                  </button>
                </div>
              </div>
            )}

            {startConversation && (
              <LiveKitRoom
                url={url}
                token={token}
                onConnected={async (room) => {
                  room.on(RoomEvent.ActiveSpeakersChanged, (speakers) => {
                    const botIsSpeaking = speakers.some(
                      (p) => p.identity !== room.localParticipant.identity
                    );
                    setIsBotSpeaking(botIsSpeaking);
                  });
                  roomRef.current = room;

                  setConnected(true);

                  await room.localParticipant.setMicrophoneEnabled(true);

                  setLogLevel("debug");

                  // room.on(
                  //   RoomEvent.ParticipantConnected,
                  //   () => updateParticipantSize(room)
                  // );
                  //
                  // room.on(
                  //   RoomEvent.ParticipantDisconnected,
                  //   () => onParticipantDisconnected(room)
                  // );
                  //
                  // updateParticipantSize(room);
                }}
                roomOptions={{
                  adaptiveStream: query.get("adaptiveStream") === "1",
                  dynacast: query.get("dynacast") === "1",
                  publishDefaults: {
                    simulcast: query.get("simulcast") === "1"
                  },
                  videoCaptureDefaults: {
                    resolution: VideoPresets.h720.resolution
                  }
                }}
                onLeave={onLeave}
              />
            )}
          </main>
        </div>
      </div>
    </DisplayContext.Provider>
  );
};
